import React, { FC, ReactText, useCallback, useState } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { SingleSelect } from 'transfix-ui/components/SingleSelect'
import { SORT_ORDER } from 'apps/fleet-planner/types'
import { SortArrowDownIcon } from 'transfix-icons'

const SORTING_OPTIONS = [
  { label: 'Ascending', value: SORT_ORDER.ASC },
  { label: 'Descending', value: SORT_ORDER.DESC },
]

export interface IFacilitiesSortingOptions {
  onChange: (selectedOption: SORT_ORDER) => void
}

export const FacilitesSortingOptions: FC<IFacilitiesSortingOptions> = ({
  onChange: onChangeProp,
}) => {
  const [selectedOption, setSelectedOption] = useState<SORT_ORDER | undefined>(undefined)

  const selectHandler = useCallback(
    (change?: ISelectOption<ReactText> | undefined) => {
      const { value } = change || {}
      setSelectedOption(value as SORT_ORDER)
      onChangeProp(value as SORT_ORDER)
    },
    [onChangeProp]
  )

  return (
    <SingleSelect
      id='facilities-sorting-options'
      dataTest='facilities-sorting-options'
      icon={<SortArrowDownIcon />}
      label='Sort By'
      options={SORTING_OPTIONS}
      onSelect={selectHandler}
      selected={selectedOption}
    />
  )
}
